import { breakpoints } from '@chegg-ui/theme';
export var ScreenSize = /*#__PURE__*/ function(ScreenSize) {
    ScreenSize["DESKTOP"] = "DESKTOP";
    ScreenSize["LAPTOP"] = "LAPTOP";
    ScreenSize["TABLET"] = "TABLET";
    ScreenSize["PHONE"] = "PHONE";
    return ScreenSize;
}({});
export const screenSizeMap = {
    ["DESKTOP"]: Number.parseInt(breakpoints.xl.min),
    ["LAPTOP"]: Number.parseInt(breakpoints.lg.min),
    ["TABLET"]: Number.parseInt(breakpoints.md.min),
    ["PHONE"]: Number.parseInt(breakpoints.sm.min)
};
